import { Loader2, RefreshCw } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useMailOutbox } from "@/hooks/queries/useMailOutbox";
import { MailOutboxPreviewRow } from "./MailOutboxPreviewRow";

export function MailOutboxPreview() {
  const { data = [], isLoading, isFetching, refetch } = useMailOutbox();

  return (
    <section className="rounded-lg border border-border bg-card">
      <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-3">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-brand-gold-dark">
            Emails
          </p>
          <h2 className="mt-1 text-sm font-semibold text-foreground">Historique d'envoi</h2>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/mail-outbox" className="text-[11px] font-medium text-info-text hover:underline">
            Voir tout
          </Link>
          <Button type="button" variant="secondary" size="sm" onClick={() => refetch()} disabled={isFetching}>
            {isFetching ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />}
            Actualiser
          </Button>
        </div>
      </div>

      <div className="divide-y divide-neutral-100">
        {isLoading ? (
          <div className="flex items-center gap-2 px-4 py-5 text-[12px] text-muted-foreground">
            <Loader2 size={13} className="animate-spin" />
            Chargement des emails...
          </div>
        ) : data.length === 0 ? (
          <p className="px-4 py-5 text-[12px] text-muted-foreground">Aucun email enregistré.</p>
        ) : (
          data.slice(0, 5).map((item) => <MailOutboxPreviewRow key={item.id} item={item} />)
        )}
      </div>
    </section>
  );
}
